import script from "./NotFoundView.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotFoundView.vue?vue&type=script&lang=ts&setup=true"

import "./NotFoundView.vue?vue&type=style&index=0&id=67019921&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67019921"]])

export default __exports__